export interface InstitutionGroup {
  region: string;
  names: string[];
  modelRegion?: boolean;
}

export const institutions: InstitutionGroup[] = [
  {
    region: 'Nordrhein-Westfalen',
    names: [
      'Caritas Eschweiler',
      'Lebenshilfe Hamm',
      'Caritas Paderborn',
      'Franz Sales Haus Essen',
      'Bonner Werkstätten',
      'SPIX e. V. Wesel',
      'Perthes-Stiftung Kamen',
      'Caritas Gladbeck',
      'Sozialwerk St. Georg Gelsenkirchen',
    ],
  },
  {
    region: 'Bayern',
    names: ['Caritas München', 'Barmherzige Brüder Oberpfalz'],
  },
  {
    region: 'Sachsen',
    names: ['Lebenshilfe Bischofswerda'],
  },
  {
    region: 'Niedersachsen',
    names: ['HA WE TEC Holzminden', 'Christophorus-Werk Lingen'],
  },
  {
    region: 'Saarland',
    names: ['Lebenshilfe Nordsaarland'],
  },
  {
    region: 'Hessen',
    names: ['Aktiv Werk Wetterau'],
  },
  {
    region: 'Berlin',
    names: ['USE gGmbH Berlin'],
  },
  {
    region: 'Thüringen',
    names: ['Diakonie Thüringen'],
  },
  {
    region: 'Modellregionen',
    names: [
      'Integrationsfachdienst Gelsenkirchen',
      'Integrationsfachdienst Kreis Warendorf',
      'LAG WfbM Sachsen-Anhalt',
    ],
    modelRegion: true,
  },
];

export const partners = [
  'LWL – Landschaftsverband Westfalen-Lippe',
  'LAG Soziale Dienste Schleswig-Holstein',
  'LAG WfbM Sachsen-Anhalt',
];